// extracted by mini-css-extract-plugin
export var purpleBanner = "purpleBanner-module--purple-banner--fd03a";
export var purpleBanner__container = "purpleBanner-module--purple-banner__container--2dedd";
export var purpleBanner__text = "purpleBanner-module--purple-banner__text--2a668";
export var purpleBanner__title = "purpleBanner-module--purple-banner__title--bcea8";